// src/components/pages/portfolios/partials/PortfolioDetailHeader.js

import React from 'react';
import CommonStyles from './../../../../styles/Common.module.css';
import styles from './../style/PortfolioDetail.module.css';
import DOMPurify from 'dompurify';

export default function PortfolioDetailHeader({ 
  po, isFollowing, handleFollowToggle, currentUserId, navigate, t, DEFAULT_PROFILE_URL 
}) {
  if (!po || !po.userId) return null;

  const IS_LAZY_PORT = po.userId === 'LAZYPORT';
  const displayNickname = IS_LAZY_PORT ? 'LAZY_PORT' : (po.nickname || t('portfolioDetail.unnamed'));
  const sanitizedNickname = DOMPurify.sanitize(displayNickname);
  const sanitizedPoName = DOMPurify.sanitize(po.name);
  const profileImage = po.profileImageUrl || DEFAULT_PROFILE_URL;

  const shouldShowFollowButton = po.userId !== currentUserId && !IS_LAZY_PORT;

  return (
    <>
      <h2 className={styles.title}>{sanitizedPoName || `${sanitizedNickname}님의 ${t('portfolioDetail.title')}`}</h2>
      <div className={styles.portfolioHeader}>
        <div className={styles.ownerProfile}>
          <img src={profileImage} alt="profile" className={styles.profileImage} />
          <div className={styles.ownerInfo}>
            <span className={styles.ownerNickname}>{sanitizedNickname}</span>
            <span className={styles.ownerDescription}>{t('portfolioDetail.ownerDescription')}</span>
          </div>
        </div>
        <div className={styles.userActionButtons}>
          {!IS_LAZY_PORT && (
            <button
              onClick={() => navigate(`/users/${po.userId}/profile`)}
              className={styles.creatorPageButton}
            >
              {t('portfolioDetail.visitPageButton')}
            </button>
          )}
          {shouldShowFollowButton && (
            <button
              onClick={handleFollowToggle}
              className={`${CommonStyles.followButton} ${isFollowing ? CommonStyles.following : ''}`}
            >
              {isFollowing ? t('portfolioDetail.followingButton') : t('portfolioDetail.followButton')}
            </button>
          )}
        </div>
      </div>
    </>
  );
}